/*
 * @Author: SK-20251129GXNS\Administrator zpx
 * @Date: 2025-12-30 13:48:48
 * @LastEditors: SK-20251129GXNS\Administrator zpx
 * @LastEditTime: 2025-12-30 14:12:18
 * @FilePath: \frontend\src\utils\fornatLocalImg.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

/**
 * 本地/线上图片兼容公用函数
 * IMAGE__WITH__TYPE 是否开启线上 [local-本地] [cdn-线上]
 */
const ImageTypeEnum = {
  CDN: 'cdn',
  LOCAL: 'local',
}
const ImageFlage = JSON.parse(localStorage.getItem('localConfig'))?.image_flage
let IMAGE__WITH__TYPE = ''

/**
 * 获取本地图片
 */
let themeIcons = null
let themeIconsList = []
const getImageUrlWithLocal = () => {
  themeIcons = import.meta.glob('@/assets/theme/**/*', { eager: true })
  themeIconsList = Object.keys(themeIcons).map((path) => {
    const relativePath = path.replace('/src/assets/theme/', '')
    return {
      url: `/${relativePath}`,
      component: themeIcons[path].default,
    }
  })
}

/**
 * 获取线上图片
 * @param {string} path - 本地图片路径
 * @returns {string} CDN路径
 */
export function getImageUrlWithCDN(path) {
  const result = path
  return result
}

/**
 * 获取线上/本地图片
 * @param {*} path - 图片路径
 * @returns
 */
const getIconsObj = (path) => {
  const obj = themeIconsList.find((e) => e.url === path)
  return obj && obj !== undefined ? obj.component : ''
}
export function getImageUrlWithCDN_LOCAL(path, type) {
  let __ImgType__
  if (
    type !== undefined &&
    type !== null &&
    type !== '' &&
    typeof type === 'string' &&
    (type === ImageTypeEnum.LOCAL || type === ImageTypeEnum.CDN)
  ) {
    __ImgType__ = type
  } else {
    __ImgType__ = IMAGE__WITH__TYPE
  }

  switch (__ImgType__) {
    case ImageTypeEnum.CDN:
      return getImageUrlWithCDN(`theme${path}`)
    case ImageTypeEnum.LOCAL:
      return getIconsObj(path)
  }
}

/**
 * 初始化获取图片类型函数
 */
const initImageData = () => {
  // 强制始终使用本地图片
  IMAGE__WITH__TYPE = ImageTypeEnum.LOCAL

  nextTick(() => {
    getImageUrlWithLocal()
  })
}
initImageData()

/**
 * 处理单个图片路径
 * @param {string} path - 原始图片路径
 * @returns {string} - 处理后的图片路径
 */
export function handleImagePath(path) {
  return getImageUrlWithCDN(path)
}